<div class="p-8">
  <div class="flex items-center justify-between mb-6">
    <div class="flex items-center space-x-3">
      <h1 class="text-3xl font-bold text-gray-900">{{ isEdit ? 'Edit Article' : 'New Article' }}</h1>
      <span *ngIf="isEdit && currentVersionNumber" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
        v{{ currentVersionNumber }}
      </span>
    </div>
    <button *ngIf="isEdit" type="button" (click)="toggleVersionPanel()"
      class="inline-flex items-center px-3 py-2 text-sm font-medium rounded-md border"
      [class.bg-blue-50]="showVersionPanel" [class.border-blue-300]="showVersionPanel"
      [class.text-blue-700]="showVersionPanel" [class.border-gray-300]="!showVersionPanel"
      [class.text-gray-700]="!showVersionPanel" [class.hover:bg-gray-50]="!showVersionPanel">
      <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      Version History
    </button>
  </div>

  <div class="flex gap-6">
  <div class="flex-1 min-w-0">

  <div class="bg-white rounded-lg shadow p-6">
    <form [formGroup]="articleForm" (ngSubmit)="onSubmit()" class="space-y-4">

      <div>
        <label class="block text-sm font-medium mb-1">Name <span class="text-red-500">*</span></label>
        <input type="text" formControlName="title"
          class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          [class.border-red-500]="articleForm.get('title')?.invalid && articleForm.get('title')?.touched">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Byline</label>
        <input type="text" formControlName="byline"
          class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Slug <span class="text-red-500">*</span></label>
        <input type="text" formControlName="slug"
          class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
        <div *ngIf="articleForm.get('slug')?.value" class="text-sm text-gray-500 mt-1">Full URL: <span class="font-mono text-gray-700">/insights/{{ articleForm.get('slug')?.value }}</span></div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Author <span class="text-red-500">*</span></label>
          <select formControlName="author"
            class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="articleForm.get('author')?.invalid && articleForm.get('author')?.touched">
            <option value="">Select an author</option>
            <option *ngFor="let profile of profiles" [value]="profile.name">{{ profile.firstName }} {{ profile.surname }}</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Date <span class="text-red-500">*</span></label>
          <input type="date" formControlName="articleDate"
            class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="articleForm.get('articleDate')?.invalid && articleForm.get('articleDate')?.touched">
        </div>
      </div>

      <div formGroupName="thumbnail">
        <label class="block text-sm font-medium mb-1">Thumbnail Image</label>
        <div class="flex items-center space-x-3">
          <button type="button" (click)="uploadThumbnail()"
            class="px-3 py-2 bg-white text-gray-700 rounded border border-gray-300 text-sm hover:bg-gray-50 flex items-center space-x-1">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
            <span>Upload</span>
          </button>
          <input type="text" formControlName="alt" placeholder="Alt text"
            class="flex-1 border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>
        <img *ngIf="articleForm.get('thumbnail.sm')?.value" [src]="articleForm.get('thumbnail.sm')?.value"
          class="mt-2 h-20 rounded object-cover" alt="Thumbnail preview">
      </div>


      <div class="flex items-center space-x-2">
        <label class="text-sm font-medium">Published</label>
        <label class="relative inline-flex items-center cursor-pointer">
          <input type="checkbox" formControlName="published" class="sr-only peer">
          <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
        </label>
      </div>

      <div class="border-t pt-6 mt-6 space-y-4">
            <h3 class="text-lg font-semibold mb-4">SEO</h3>

          <div>
        <label class="block text-sm font-medium mb-1">Title <span class="text-red-500">*</span></label>
        <input type="text" formControlName="seoTitle"
          class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          [class.border-red-500]="articleForm.get('seoTitle')?.invalid && articleForm.get('seoTitle')?.touched">
        <p class="text-gray-500 text-xs mt-1">| {{ siteName }} is appended to the end</p>
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Description <span class="text-red-500">*</span></label>
        <textarea formControlName="description" rows="2"
          class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          [class.border-red-500]="articleForm.get('description')?.invalid && articleForm.get('description')?.touched"></textarea>
      </div>
      </div>

      <!-- Content Blocks -->
      <div class="border-t pt-6 mt-6" formArrayName="blocks">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-xl font-semibold text-gray-900">Content Blocks</h2>
        </div>

        <div *ngIf="blocks.length === 0" class="text-gray-500 text-sm mb-4">No content blocks yet. Add one below.</div>

        <div #blocksContainer>
          <div *ngFor="let block of blocks.controls; let i = index" [formGroupName]="i"
            class="border rounded-lg mb-4 bg-gray-50">

            <div class="flex items-center justify-between px-4 py-3 bg-gray-100 rounded-t-lg border-b">
              <div class="flex items-center space-x-3">
                <div class="drag-handle text-gray-400 hover:text-gray-600 cursor-grab">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16"></path>
                  </svg>
                </div>
                <span class="text-sm font-medium text-gray-700">
                  <ng-container *ngFor="let bt of blockTypes">
                    <ng-container *ngIf="bt.value === block.get('type')?.value">{{ bt.label }}</ng-container>
                  </ng-container>
                </span>
              </div>
              <button type="button" (click)="removeBlock(i)" class="text-red-500 hover:text-red-700 text-sm">Remove</button>
            </div>

            <div class="p-4 space-y-3">
              <ng-container [ngSwitch]="block.get('type')?.value">

                <!-- Text Block -->
                <ng-container *ngSwitchCase="'text'">
                  <div>
                    <label class="block text-sm font-medium mb-1">Title</label>
                    <input type="text" formControlName="title" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500">
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1">Text <span class="text-red-500">*</span></label>
                    <app-tiptap-editor formControlName="text"></app-tiptap-editor>
                  </div>
                </ng-container>

                <!-- Image Only Block -->
                <ng-container *ngSwitchCase="'image'">
                  <div formGroupName="image" class="space-y-3">
                    <div class="flex items-center justify-between">
                      <label class="block text-sm font-medium">Image <span class="text-red-500">*</span></label>
                      <button type="button" (click)="uploadBlockImage(i)"
                        class="px-2 py-1 bg-white text-gray-700 rounded border border-gray-300 text-xs hover:bg-gray-50 flex items-center space-x-1">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                        <span>Upload</span>
                      </button>
                    </div>
                    <div *ngIf="!block.get('image.lg')?.value && block.get('image.lg')?.touched" class="text-red-500 text-xs">Image is required</div>
                    <img *ngIf="block.get('image.lg')?.value" [src]="block.get('image.sm')?.value" class="h-24 rounded object-cover" alt="Preview">
                    <div>
                      <label class="block text-sm font-medium mb-1">Alt Text <span class="text-red-500">*</span></label>
                      <input type="text" formControlName="alt" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        [class.border-red-500]="block.get('image.alt')?.invalid && block.get('image.alt')?.touched">
                    </div>
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1">Caption</label>
                    <input type="text" formControlName="text" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Optional caption">
                  </div>
                </ng-container>

                <!-- Video Only Block -->
                <ng-container *ngSwitchCase="'video'">
                  <div>
                    <label class="block text-sm font-medium mb-1">Video URL <span class="text-red-500">*</span></label>
                    <input type="text" formControlName="videoUrl" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="https://youtube.com/... or https://vimeo.com/..."
                      [class.border-red-500]="block.get('videoUrl')?.invalid && block.get('videoUrl')?.touched">
                    <div *ngIf="block.get('videoUrl')?.invalid && block.get('videoUrl')?.touched" class="text-red-500 text-xs mt-1">Video URL is required</div>
                    <div *ngIf="getVideoEmbedUrl(block.get('videoUrl')?.value) as embedUrl" class="mt-3" style="max-width:480px"><div class="relative w-full" style="padding-bottom: 56.25%"><iframe class="absolute inset-0 w-full h-full rounded" [src]="embedUrl" allowfullscreen></iframe></div></div>
                  </div>
                </ng-container>

              </ng-container>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap gap-2">
          <button *ngFor="let bt of blockTypes" type="button" (click)="addBlock(bt.value)"
            class="px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 text-gray-700">
            + {{ bt.label }}
          </button>
        </div>
      </div>

      <p class="text-sm text-gray-500"><span class="text-red-500">*</span> Required fields</p>

      <div class="flex space-x-2 pt-6">
        <button type="submit" [disabled]="articleForm.invalid"
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-gray-300">
          {{ isEdit ? 'Update Article' : 'Create Article' }}
        </button>
        <button type="button" (click)="onCancel()"
          class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
          Back to Articles
        </button>
      </div>
    </form>
  </div>
  </div>

  <!-- Version History Panel -->
  <div *ngIf="showVersionPanel" class="w-80 flex-shrink-0">
    <div class="bg-white rounded-lg shadow sticky top-8">
      <div class="px-4 py-3 border-b flex items-center justify-between">
        <h3 class="text-sm font-semibold text-gray-900">Version History</h3>
        <button type="button" (click)="toggleVersionPanel()" class="text-gray-400 hover:text-gray-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      <div class="max-h-[calc(100vh-12rem)] overflow-y-auto">
        <div *ngIf="versions.length === 0" class="p-4 text-sm text-gray-500">No versions yet.</div>
        <div *ngFor="let version of versions"
          class="px-4 py-3 border-b last:border-b-0 hover:bg-gray-50 cursor-pointer"
          [class.bg-blue-50]="version.versionNumber === currentVersionNumber">
          <div class="flex items-center justify-between">
            <div>
              <span class="text-sm font-medium text-gray-900">v{{ version.versionNumber }}</span>
              <span *ngIf="version.versionNumber === currentVersionNumber"
                class="ml-1.5 text-xs text-blue-600 font-medium">current</span>
            </div>
            <div class="flex items-center space-x-1">
              <button type="button" (click)="previewVersionSnapshot(version)"
                class="text-xs text-blue-600 hover:text-blue-800 px-1.5 py-0.5 rounded hover:bg-blue-50">
                Preview
              </button>
              <button *ngIf="version.versionNumber !== currentVersionNumber"
                type="button" (click)="revertToVersion(version)"
                class="text-xs text-amber-600 hover:text-amber-800 px-1.5 py-0.5 rounded hover:bg-amber-50">
                Revert
              </button>
            </div>
          </div>
          <div class="text-xs text-gray-500 mt-0.5">{{ version.createdAt | date:'d MMM y, HH:mm' }}</div>
          <div *ngIf="version.note" class="text-xs text-gray-600 mt-0.5 italic">{{ version.note }}</div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

<!-- Version Preview Overlay -->
<div *ngIf="previewVersion" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-start justify-center pt-8 overflow-y-auto">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 mb-8">
    <div class="px-6 py-4 border-b flex items-center justify-between sticky top-0 bg-white rounded-t-lg z-10">
      <div>
        <h2 class="text-lg font-semibold text-gray-900">
          Version {{ previewVersion.versionNumber }} Preview
        </h2>
        <p class="text-sm text-gray-500">{{ previewVersion.createdAt | date:'d MMM y, HH:mm' }}</p>
        <p *ngIf="previewVersion.note" class="text-sm text-gray-600 italic">{{ previewVersion.note }}</p>
      </div>
      <div class="flex items-center space-x-2">
        <button *ngIf="previewVersion.versionNumber !== currentVersionNumber"
          type="button" (click)="revertToVersion(previewVersion)"
          class="px-3 py-1.5 text-sm font-medium text-white bg-amber-500 rounded hover:bg-amber-600">
          Revert to this version
        </button>
        <button type="button" (click)="closePreview()"
          class="px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200">
          Close
        </button>
      </div>
    </div>
    <div class="p-6">
      <div class="grid grid-cols-2 gap-4 mb-6 text-sm">
        <div>
          <span class="font-medium text-gray-500">Title:</span>
          <span class="ml-2 text-gray-900">{{ previewVersion.snapshot?.title }}</span>
        </div>
        <div>
          <span class="font-medium text-gray-500">Author:</span>
          <span class="ml-2 text-gray-900">{{ previewVersion.snapshot?.author || '—' }}</span>
        </div>
        <div>
          <span class="font-medium text-gray-500">Slug:</span>
          <span class="ml-2 text-gray-900">{{ previewVersion.snapshot?.slug }}</span>
        </div>
        <div>
          <span class="font-medium text-gray-500">Date:</span>
          <span class="ml-2 text-gray-900">{{ previewVersion.snapshot?.articleDate ? (previewVersion.snapshot.articleDate | date:'d MMM y') : '—' }}</span>
        </div>
        <div>
          <span class="font-medium text-gray-500">Published:</span>
          <span class="ml-2" [class.text-green-600]="previewVersion.snapshot?.published" [class.text-red-600]="!previewVersion.snapshot?.published">
            {{ previewVersion.snapshot?.published ? 'Yes' : 'No' }}
          </span>
        </div>
      </div>

      <h3 class="text-sm font-semibold text-gray-700 mb-3 border-t pt-4">Content Blocks</h3>
      <div *ngIf="getPreviewBlocks().length === 0" class="text-sm text-gray-500">No content blocks in this version.</div>
      <div *ngFor="let block of getPreviewBlocks(); let i = index" class="border rounded-lg mb-3 bg-gray-50">
        <div class="px-4 py-2 bg-gray-100 rounded-t-lg border-b">
          <span class="text-xs font-medium text-gray-600 uppercase">{{ block.type }}</span>
          <span *ngIf="block.title" class="text-xs text-gray-500 ml-2">— {{ block.title }}</span>
        </div>
        <div *ngIf="block.text" class="p-4 prose prose-sm max-w-none text-sm" [innerHTML]="block.text"></div>
        <div *ngIf="block.videoUrl" class="px-4 pb-3 text-xs text-gray-500">Video: {{ block.videoUrl }}</div>
      </div>
    </div>
  </div>
</div>

<app-confirmation-modal
  [show]="showRevertModal"
  title="Revert Article"
  [message]="'Revert to version ' + (versionToRevert?.versionNumber || '') + '? This will save a new version with the reverted content.'"
  confirmText="Revert"
  (confirm)="confirmRevert()"
  (cancel)="cancelRevert()">
</app-confirmation-modal>
